<template>
    <div class="row">
        <div class="col-lg-6 text-left">
            <div class="_education my-3" v-if="user.education.length > 0">
                <h6 class="font-weight-bold text-color-kllaar"><i class="fa fa-graduation-cap font-icon-cv"></i> Educación</h6>
                <div v-for="(item, key) in user.education" :key="key" class="ml-2 mb-2">
                    <div class="d-flex">
                        <i class="fas fa-circle mr-1" style="font-size: 6px;margin-top: 8px"/>
                        <p class="font-weight-bold mb-0">
                            {{ item.institucion }}
                            <i class="fas fa-check-circle text-success" v-if="item.validated && isGold"/>
                        </p>
                    </div>
                    <small>
                        {{ item.ano_inicio + ' - ' + item.ano_fin }}
                    </small>
                </div>
            </div>
            <div class="_skill my-3" v-if="user.skill.length > 0">
                <h6 class="font-weight-bold text-color-kllaar"><i class="fa fa-magic font-icon-cv"></i> Habilidades</h6>
                <div v-for="(item, key) in user.skill" :key="key" class="ml-2 mb-0">

                    <div class="d-flex">
                        <i class="fas fa-circle mr-1" style="font-size: 6px;margin-top: 8px"/>
                        <p class="font-weight-bold mb-0">
                            {{ item.habilidad }}
                            <i class="fas fa-check-circle text-success" v-if="item.validated && isGold"/>
                        </p>
                    </div>

                </div>
            </div>
            <div class="_software my-3" v-if="user.software.length > 0">
                <h6 class="font-weight-bold text-color-kllaar"><i class="fa fa-desktop font-icon-cv"></i> Software</h6>
                <div v-for="(item, key) in user.software" :key="key" class="ml-2 mb-0">

                    <div class="d-flex">
                        <i class="fas fa-circle mr-1" style="font-size: 6px;margin-top: 8px"/>
                        <p class="font-weight-bold mb-0">
                            {{ item.software }}
                            <i class="fas fa-check-circle text-success" v-if="item.validated && isGold"/>
                        </p>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-lg-6 text-left">
            <div class="_experience my-3" v-if="user.experience.length > 0">
                <h6 class="font-weight-bold text-color-kllaar"><i class="fa fa-briefcase font-icon-cv"></i> Experiencia Laboral</h6>

                <div v-for="(item, key) in user.experience" :key="key" class="ml-2 mb-0">
                    <div class="d-flex">
                        <i class="fas fa-circle mr-1" style="font-size: 6px;margin-top: 8px"/>
                        <p class="font-weight-bold mb-0">
                            {{ item.puesto }}
                            <i class="fas fa-check-circle text-success" v-if="item.validated && isGold"/>
                        </p>
                    </div>
                    <small>{{ item.empresa }}: </small>
                    <small>{{ item.descripcion }}</small>
                </div>

            </div>
            <div class="_project my-3" v-if="user.project.length > 0">
                <h6 class="font-weight-bold text-color-kllaar"><i class="fa fa-folder-open font-icon-cv"></i> Proyectos y publicaciones</h6>

                <div v-for="(item, key) in user.project" :key="key" class="ml-2 mb-0">
                    <div class="d-flex">
                        <i class="fas fa-circle mr-1" style="font-size: 6px;margin-top: 8px"/>
                        <p class="font-weight-bold mb-0">
                            {{ item.nombre }}
                            <i class="fas fa-check-circle text-success" v-if="item.validated && isGold"/>
                        </p>
                    </div>
                    <small>
                        {{ item.ano_fin ? '/' + item.mes + ' ' + item.ano_fin : '' }}
                    </small><br>
                    <small>{{ item.emisor }}</small><br>
                    <small>{{ item.tipo }}</small>
                </div>

            </div>
            <div class="_achievement my-3" v-if="user.achievement.length > 0">
                <h6 class="font-weight-bold text-color-kllaar"><i class="fa fa-trophy font-icon-cv"></i> Logros y reconocimientos</h6>

                    <div v-for="(item, key) in user.achievement" :key="key" class="ml-2 mb-0">
                        <div class="d-flex">
                            <i class="fas fa-circle mr-1" style="font-size: 6px;margin-top: 8px"/>
                            <p class="font-weight-bold mb-0">
                                {{ item.nombre }}
                                <i class="fas fa-check-circle text-success" v-if="item.validated && isGold"/>
                            </p>
                        </div>
                        <small>{{ item.funcion_desempenada }}</small><br>
                        <small>{{ item.academico }}</small>
                    </div>

            </div>
            <div class="_service" v-if="user.service.length > 0">
                <h6 class="font-weight-bold text-color-kllaar"><i class="fa fa-file font-icon-cv"></i> Servicio y voluntariado</h6>

                    <div v-for="(item, key) in user.service" :key="key" class="ml-2 mb-0">
                        <div class="d-flex">
                            <i class="fas fa-circle mr-1" style="font-size: 6px;margin-top: 8px"/>
                            <p class="font-weight-bold mb-0">
                                {{ item.organizacion }}
                                <i class="fas fa-check-circle text-success" v-if="item.validated && isGold"/>
                            </p>
                        </div>
                        <small>{{ item.funcion_desempenada }}</small><br>
                        <small>{{ item.ano_inicio + ' - ' + item.ano_fin }}</small>
                    </div>

            </div>
        </div>
    </div>
</template>
<style>
.font-icon-cv{
    color: #f9c332;
}
</style>
<script>
export default {
    props: {
        user: Object,
        isGold: Boolean
    },
    data() {
        return {}
    },
    created() {

    },
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/candidates/components/CurriculumPreview.vue